import { useState } from 'react';
import PanelContent from '@shared/components/PanelContent';
import PanelSkeleton from '@shared/components/PanelSkeleton';
import RetryableError from '@shared/components/RetryableError';
import { ApiRequestError } from '@api/client/apiClient';
import { useOrders } from './hooks/useOrders';
import OrderList from './components/OrderList';
import OrderDetail from './components/OrderDetail';

export default function OrdersPage() {
  const [selectedOrderId, setSelectedOrderId] = useState<string | null>(null);
  const { data: orders, isLoading, error, refetch } = useOrders();

  if (selectedOrderId) {
    return (
      <PanelContent>
        <OrderDetail orderId={selectedOrderId} onBack={() => setSelectedOrderId(null)} />
      </PanelContent>
    );
  }

  if (isLoading) return <PanelSkeleton />;

  if (error || !orders) {
    const correlationId =
      error instanceof ApiRequestError ? error.apiError.correlationId : undefined;
    return (
      <RetryableError
        message={error?.message ?? 'Failed to load orders'}
        correlationId={correlationId}
        onRetry={() => void refetch()}
      />
    );
  }

  return (
    <PanelContent>
      <div data-testid="page-orders">
        <OrderList
          orders={orders}
          loading={isLoading}
          onSelectOrder={setSelectedOrderId}
          selectedOrderId={selectedOrderId}
        />
      </div>
    </PanelContent>
  );
}
